/*
 * @Descripttion: 
 * @version: 
 * @Author: wangliuyang
 * @Date: 2023-04-04 15:43:18
 * @LastEditors: wangliuyang
 * @LastEditTime: 2023-06-30 15:44:47
 */
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import VueLazyLoad from 'vue-lazyload'
import 'babel-polyfill' // ie8-11

// import ElementUI from 'element-ui'
import { Tabs, RadioGroup, RadioButton, TabPane, Progress, DatePicker, Breadcrumb, BreadcrumbItem, Rate, Upload, Dialog } from 'element-ui';

import 'style/reset.css'
import 'style/border.css'
import 'style/iconfont.css'
import 'element-ui/lib/theme-chalk/index.css'
import './assets/css/override-element-ui.css';

import VueCookies from 'vue-cookies'
Vue.use(VueCookies)

Vue.use(Tabs);
Vue.use(RadioGroup);
Vue.use(RadioButton);
Vue.use(TabPane);
Vue.use(Progress);
Vue.use(DatePicker);
Vue.use(Breadcrumb);
Vue.use(BreadcrumbItem);
Vue.use(Rate);
Vue.use(Upload);
Vue.use(Dialog);
Vue.config.productionTip = false;

//是否是H5
Vue.prototype.$isFe = App.computed._isMobile()

//tost
import 'common/toast/toast.css';
import Toast from 'common/toast/index';
Vue.use(Toast);
import request1 from 'js/request1'
//request 
import request from 'basecommon/js/request';

import request2 from 'js/request2'


Vue.prototype.$request = request;
Vue.prototype.$requestNet = request1;
Vue.prototype.$requestJava = request2;

import infiniteScroll from "vue-infinite-scroll";
Vue.use(infiniteScroll);

// switchWeb
import switchWeb from 'js/switchWeb';
Vue.use(switchWeb);

//routers 
import routers from 'vue-router'
Vue.prototype.$routers = routers;

//axios
import axios from 'axios'
Vue.prototype.$axios = axios


// set title
import VueWechatTitle from 'vue-wechat-title'
Vue.use(VueWechatTitle)
import { initUserTrack, trackPageView } from 'basecommon/js/userTrack'

initUserTrack({
    source: 'projectSq',
    appName: '思泉素养官网',
    appKey: 'siquansuyang-web',
    partnerId: '10043'
})

var chunkReloadKey = '__bx_chunk_reload_path__';

function isChunkLoadError(error) {
    return /Loading chunk [\d]+ failed|ChunkLoadError/i.test((error && error.message) || '');
}

router.onError(function(error) {
    if (!isChunkLoadError(error)) return;

    var currentPath = window.location.pathname + window.location.search;
    try {
        if (window.sessionStorage.getItem(chunkReloadKey) !== currentPath) {
            window.sessionStorage.setItem(chunkReloadKey, currentPath);
            window.location.reload();
            return;
        }
    } catch (storageError) {}

    Vue.prototype.$toast.center('页面资源加载失败，请刷新页面后重试');
});

Vue.use(VueLazyLoad, {
    preLoad: 1.3,
    loading:'http://static.domain.com/error.png',
    error:'http://static.domain.com/loading.gif',
    attempt:1
})

/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    store,
    components: { App },
    template: '<App/>'
})

// baidu tongji
var _hmt = _hmt || [];
window._hmt = _hmt; // 必须把_hmt挂载到window下，否则找不到
(function() {
    var hm = document.createElement("script");
    //  测试环境
    // hm.src = "https://hm.baidu.com/hm.js?"+ '11f9fe669ec94fa5097594da350779d2';
    //  正式环境
    hm.src = "https://hm.baidu.com/hm.js?" + '1033eb8bf9578881b70947597f7ba892';
    var s = document.getElementsByTagName("script")[0];
    s.parentNode.insertBefore(hm, s);
})();

router.beforeEach((to, from, next) => {
    const studentCode = store.state.user&&store.state.user.Code;
    // 移动端首页
    if(to.path == '/index' && Vue.prototype.$isFe) {
        router.replace('/indexFe');
    }

    if(to.path == 'myAssets/myCourse?tab=second&subtab=faceTo' && !studentCode) {
        router.replace({
            path: "/loginCode",
            query: {
              redirect: router.currentRoute.fullPath,
            },
          });
    }


    if (_hmt) {
        if (to.path) {
            _hmt.push(['_trackPageview', '/#' + to.fullPath]);
        }
    }
    next();
});

router.afterEach((to) => {
    try {
        if (window.sessionStorage.getItem(chunkReloadKey) === to.fullPath) {
            window.sessionStorage.removeItem(chunkReloadKey);
        }
    } catch (storageError) {}
    trackPageView(to);
});



// WEBPACK FOOTER //
// ./src/main.js